import React from 'react'
import styled from 'styled-components'

const TableTitle = ({title}) => {
  return (
    <Title>{title}</Title>
  )
}

const Title= styled.h3`
    text-align: center;
`

export default TableTitle